__turbopack_context__.v({
  "buttonCircle": "CommitmentSubNav-module-scss-module__yiqspG__buttonCircle",
  "commitmentIconWrapper": "CommitmentSubNav-module-scss-module__yiqspG__commitmentIconWrapper",
  "commitmentNav": "CommitmentSubNav-module-scss-module__yiqspG__commitmentNav",
  "commitmentNavContainer": "CommitmentSubNav-module-scss-module__yiqspG__commitmentNavContainer",
  "currentPage": "CommitmentSubNav-module-scss-module__yiqspG__currentPage",
  "currentPageSeparator": "CommitmentSubNav-module-scss-module__yiqspG__currentPageSeparator",
  "fade-in": "CommitmentSubNav-module-scss-module__yiqspG__fade-in",
  "icon--barn": "CommitmentSubNav-module-scss-module__yiqspG__icon--barn",
  "icon--hills": "CommitmentSubNav-module-scss-module__yiqspG__icon--hills",
  "icon--people": "CommitmentSubNav-module-scss-module__yiqspG__icon--people",
  "iconBox": "CommitmentSubNav-module-scss-module__yiqspG__iconBox",
  "indexIndicator": "CommitmentSubNav-module-scss-module__yiqspG__indexIndicator",
  "isExpanded": "CommitmentSubNav-module-scss-module__yiqspG__isExpanded",
  "isHidden": "CommitmentSubNav-module-scss-module__yiqspG__isHidden",
  "nav": "CommitmentSubNav-module-scss-module__yiqspG__nav",
  "page": "CommitmentSubNav-module-scss-module__yiqspG__page",
  "pageArrow": "CommitmentSubNav-module-scss-module__yiqspG__pageArrow",
  "pageLabel": "CommitmentSubNav-module-scss-module__yiqspG__pageLabel",
  "pageList": "CommitmentSubNav-module-scss-module__yiqspG__pageList",
  "shrink": "CommitmentSubNav-module-scss-module__yiqspG__shrink",
});
